import { Button, Logo } from "@mdnt-pf/design-system";
import { Link } from "react-router";

import { PageTitle } from "#app/components/page-title.tsx";

export default function Index() {
  return (
    <main className="font-poppins grid h-full flex-1 place-items-center">
      <PageTitle>Home</PageTitle>
      <div className="place-items-center px-4 py-16">
        <div className="flex max-w-md flex-col items-center text-center">
          <div className="animate-slide-top [animation-fill-mode:backwards] xl:animate-slide-left xl:[animation-delay:0.5s] xl:[animation-fill-mode:backwards]">
            <Logo className="size-20 xl:-mt-4" />
          </div>
          <h1
            data-heading
            className="mt-8 animate-slide-top text-4xl font-medium text-foreground [animation-delay:0.3s] [animation-fill-mode:backwards] md:text-5xl xl:mt-4 xl:animate-slide-left xl:text-6xl xl:[animation-delay:0.8s] xl:[animation-fill-mode:backwards]"
          >
            787 Study
          </h1>

          <div className="mt-8 flex animate-slide-top space-x-4 [animation-delay:0.5s] [animation-fill-mode:backwards] xl:animate-slide-left xl:[animation-delay:0.8s] xl:[animation-fill-mode:backwards]">
            <Button asChild variant="outline">
              <Link to="/practice">Start</Link>
            </Button>

            <Button asChild variant="plain">
              <Link to="/login">Login</Link>
            </Button>
          </div>
        </div>
      </div>
    </main>
  );
}
